import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GestaoOnboardingService {

  constructor(
    private http: HttpService,
  ) { }

  buscaOnboard(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/onboard/situation', data, successHandle, errorHandle);

  }

}
